import { COMPANY_IMAGE, uploadImage } from './FileUploadActionCreators';
import { s3KeyToUrl } from 'utils/images';

export const SAVE_PAYMENT_PLANS = 'SAVE_PAYMENT_PLANS';

export const SAVE_COMPANY_CHANNELS = 'SAVE_COMPANY_CHANNELS';

export const START_FETCHING_CHANNELS = 'START_FETCHING_CHANNELS';
export const STOP_FETCHING_CHANNELS = 'STOP_FETCHING_CHANNELS';
export const SAVE_COMPANY_EMPLOYEES = 'SAVE_COMPANY_EMPLOYEES';
export const SAVE_INCOMPLETE_COMPANY_ID = 'SAVE_INCOMPLETE_COMPANY_ID';
export const CLEAR_INCOMPLETE_COMPANY_ID = 'CLEAR_INCOMPLETE_COMPANY_ID';

import fetchAPI from 'utils/fetchAPI';

const savePaymentPlans = ({ plans }) => ({
  type: SAVE_PAYMENT_PLANS,
  plans,
});

const saveChannels = channels => ({
  type: SAVE_COMPANY_CHANNELS,
  channels,
});

const startFetchingChannels = () => ({
  type: START_FETCHING_CHANNELS,
});

const stopFetchingChannels = () => ({
  type: STOP_FETCHING_CHANNELS,
});

const saveEmployees = employees => ({
  type: SAVE_COMPANY_EMPLOYEES,
  employees,
});

const saveIncompleteCompanyId = id => ({
  type: SAVE_INCOMPLETE_COMPANY_ID,
  id,
});

const clearIncompleteCompanyId = () => ({
  type: CLEAR_INCOMPLETE_COMPANY_ID,
});

export const createCompany = ({
  name,
  industryTypes: industry_type,
  email,
  address,
  country,
  postalCode: postal_code,
  logo: imageData,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    let maybeUploadImage;
    if (imageData) {
      maybeUploadImage = uploadImage({ imageData, type: COMPANY_IMAGE, token });
    } else {
      maybeUploadImage = new Promise(resolve => resolve(null));
    }

    maybeUploadImage
      .then(imageKey =>
        fetchAPI({
          endpoint: '/companies',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name,
            industry_type,
            email,
            address,
            country,
            postal_code,
            display_pic: imageKey ? s3KeyToUrl(imageKey) : null,
          }),
        })
          .then(res => res.json())
          .then(json => {
            if (json.status_code && json.status_code !== 200) {
              reject(json.error);
            }
            dispatch(saveIncompleteCompanyId(json.data.id));
            resolve(json.data);
          })
      )
      .catch(e => reject(e));
  });

export const getCompanyOwners = ({ companyId }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/${companyId}/owners`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        if (json.status_code && json.status_code !== 200) {
          reject(json.error);
        }
        resolve(json);
      });
  });

export const getPaymentPlans = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      method: 'GET',
      endpoint: '/companies/payment-plan',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        if (json.status_code && json.status_code !== 200) {
          reject(json.error);
        }
        dispatch(savePaymentPlans({ plans: json.data }));
        resolve(json.data);
      });
  });

export const getCompany = ({ companyId }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/${companyId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        if (json.status_code && json.status_code !== 200) {
          reject(json.error);
        }
        resolve(json);
      });
  });

export const getCompanyChannels = ({ companyId }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    const user = getState().users.user;
    dispatch(startFetchingChannels());
    fetchAPI({
      endpoint: `/companies/${companyId}/channel`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        if (json.status_code && json.status_code !== 200) {
          reject(json.error);
        }
        dispatch(
          saveChannels(
            json.data.filter(
              c =>
                c.creator.id === user.id ||
                c.managers.map(a => a.id).indexOf(user.id) >= 0
            )
          )
        );
        dispatch(stopFetchingChannels());
        resolve(json.data);
      });
  });

export const editCompany = ({
  name,
  industryTypes: industry_type,
  email: contact_email,
  address,
  country,
  postalCode: postal_code,
  logo,
  companyId,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/${companyId}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        name,
        industry_type,
        contact_email,
        address,
        country,
        postal_code,
      }),
    })
      .then(res => res.json())
      .then(json => {
        if (json.status_code && json.status_code !== 200) {
          reject(json.error);
        }
        resolve(json);
      });
  });

export const updateCompanyPlan = ({ companyId, plan, nonce }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/${companyId}/upgrade`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        payment_plan_id: parseInt(plan, 10),
        payment_method_nonce: nonce,
      }),
    })
      .then(res => res.json())
      .then(json => {
        if (json.status_code && json.status_code !== 200) {
          reject(json.error_message);
        }
        resolve(json);
        dispatch(clearIncompleteCompanyId());
      });
  });

export const getEmployees = ({ companyId, from = 0, size = 100 }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/${companyId}/employees?from=${from}&size=${size}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(res => {
      if (res.status === 200) {
        return res.json().then(json => {
          dispatch(saveEmployees(json.employees));
          return resolve(json.employees);
        });
      }
      return reject();
    });
  });

export const getEmployeesIfNeeded = ({ companyId, from = 0, size = 100 }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const employees = getState().companies.get('employees');
    if (employees.length === 0) {
      dispatch(getEmployees({ companyId, from, size }));
    }
  });

export const addEmployees = ({ companyId, employeeIds: employee_ids }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/${companyId}/employees`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ employee_ids }),
    }).then(res => {
      if (res.status === 200) return resolve();
      return reject();
    });
  });

export const removeEmployee = ({ companyId, employeeId }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/${companyId}/employees/${employeeId}`,
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(res => {
      if (res.status === 200) return resolve();
      return reject();
    });
  });

const handleResponse = ({ resolve, reject, json }) => {
  if (json.error_code) {
    reject(json.error_message);
  }
  if (json.status_code && json.status_code !== 200) {
    reject(json.error);
  }
  resolve(json);
};

export function inviteEmployees({ companyId, contacts, subject, message }) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;
      fetchAPI({
        endpoint: `/companies/${companyId}/employees/invite`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ contacts, subject, message }),
      })
        .then(res => res.json())
        .then(json => handleResponse({ resolve, reject, json }));
    });
}



// WEBPACK FOOTER //
// ./app/actions/CompanyActionCreators.js